import register from "./register";
import config from "./config";
import lands from "./lands/index";

/**
 * Object containing various services.
 * @type {any}
 */
export const services = {
  register,
  config,
  lands,
};
